module.exports = __webpack_public_path__ + "static/media/magnifying-glass.e52f6c65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/magnifying-glass.svg
// module id = 979
// module chunks = 0